import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducers";

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

/* const store = createStore(rootReducer, applyMiddleware(thunk)); */

const store = createStore(persistedReducer, applyMiddleware(thunk));
const persistor = persistStore(store);

const storepersist = { store, persistor };

export default storepersist;
